import { useAuth } from '../auth/use-auth.js';
import { BrandMark } from './BrandMark.js';
import { LoginScreen } from './LoginScreen.js';
import { ProtectedShell } from './ProtectedShell.js';

export function AuthGate() {
  const auth = useAuth();
  if (auth.phase === 'BOOTING') {
    return (
      <main className="system-state" aria-busy="true" aria-labelledby="session-title">
        <div className="system-state__panel">
          <BrandMark />
          <p className="eyebrow">Secure session</p>
          <h1 id="session-title">Restoring your session</h1>
          <p>Checking this browser for an active pharmacy workspace session.</p>
          <span className="loading-line" aria-hidden="true" />
        </div>
      </main>
    );
  }
  if (auth.phase === 'AUTHENTICATED' && auth.session) {
    return <ProtectedShell session={auth.session} onLogout={auth.logout} />;
  }
  return (
    <LoginScreen
      onLogin={auth.login}
      onRequestRecovery={auth.requestPasswordRecovery}
      pending={auth.loginPending}
      message={auth.message}
      sessionExpired={auth.phase === 'SESSION_EXPIRED'}
      recoveryDeliveryEnabled={import.meta.env.VITE_AUTH_EMAIL_DELIVERY_ENABLED === 'true'}
    />
  );
}
